import { AccountsEntity } from '@/domain/entities/account';
import { CreateAccountPayload } from '@/domain/ports/account/payloads';
import { AccountsRepository } from '@/domain/ports/account/repositories';

export class CreateAccountUseCase {
  constructor(private readonly repository: AccountsRepository) {}

  async create(payload: CreateAccountPayload): Promise<AccountsEntity> {
    const account = await this.repository.create(payload);

    return account;
  }
}
